import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const ImageQuestion = ({ options = [], onSelect, defaultAnswer = null }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelect = (option) => {
    setSelectedOption(option);
    if (onSelect) {
      onSelect(option);
    }
  };

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values) {
      setSelectedOption(defaultAnswer.values[0])
    }
  }, [])

  return (
    <View style={styles.container}>
      {options.map((option, index) => (
        <TouchableOpacity
          style={[styles.optionContainer, { borderColor: selectedOption === option.label ? '#F65D79' : 'F999999' }]}
          key={index}
          onPress={() => handleSelect(option.label)}
        >
          <View>
            <Image
              style={styles.optionImage}
              source={{ uri: option.imageUrl }}></Image>
            <Text style={styles.optionText}>{`${option.label}`}</Text>
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 15,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  optionContainer: {
    borderRadius: 8,
    borderWidth: 3,
    width: 160,
    height: 212,
    marginBottom: 25,
  },
  optionImage: {
    width: 150,
    height: 150,
  },
  optionText: {
    marginLeft: 15,
    width: 120,
    textAlign: 'center',
    fontSize: 14,
    color: '#000000',
    marginTop: 15,
    fontFamily: FONT_STYLE.MEDIUM
  },
  innerSelect: {
    backgroundColor: '#F65D79',
  }
});

export default ImageQuestion;
